const allPubData = [
    {
        id: 1,
        title: 'The Shenanigans of Nkiru',
        author: ' Usman, Sani H',
        isbn: '978-0-7356-5274-0',
        journal: 'Ejuke Series',
        pubdate: 'June 2020',
        link: 'https://www.sciencedirect.com/science/article/pii/S0960270120300831',
        
},

    {
        id: 2,
        title: 'Dictionary of the Hausa language',
        author: ' Adaeze, Hauwa A.',
        isbn: '778-0-3456-5274-3',
        journal: 'Nigerian Journal of Linguistics',
        pubdate: 'June 1989',
        link: 'https://www.sciencedirect.com/science/article/pii/S0960270120300831',
        
},

    {
        id: 3,
        title: 'The British: Masters of colonization',
        author: ' Dike, Gregogry H',
        journal: 'Forensics Science International Genetics',
        
},

    {
        id: 4,
        title: 'Encyclopedia',
        author: ' Abdul, Chukwuebuka',
    
},

    {   id: 5,
        title: 'The British: Masters of colonization',
        author: ' Dike, Gregogry H',
    
},

    {
        id: 6,
        title: 'Dictionary of the Hausa language',
        author: ' Robinson, Charles H',
    
},
]

export { allPubData }